import { Box, Typography } from '@mui/material';
import React from 'react';

const AdminFooter = () => (
  <Box component="footer" sx={{ py: 1.5, px: { xs: 2, md: 3 }, borderTop: '1px solid', borderColor: 'divider' }}>
    <Typography variant="caption" color="text.secondary">
      © {new Date().getFullYear()} Job Flow Connect. All rights reserved.
    </Typography>
  </Box>
);

export default AdminFooter;
